export const loginVariants = {
    hidden:{
      opacity:0
    },
    visible:{
      opacity:1,
      transition:{duration:1.5,ease: "easeInOut"}
    }
}